export default function useServiceProvider({ provider }: { provider: string }) {
  const label = computed(() => `Visit ${provider} website - opens in new tab`)

  return { label }
}
